var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-o-request-section no-print"},[_c('div',{staticClass:"c-o-request-section__inner c-o-request-section__inner--centered"},[_c('div',{staticClass:"c-o-request-section__main c-o-request-section__main--large"},[_c('p',[_vm._v(_vm._s(_vm.text))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19d32761","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/atoms/SectionNoticeBox.vue
// module id = 1304
// module chunks = 0